import { Component, OnInit, Input, Output, EventEmitter, Renderer2, ChangeDetectorRef, NgZone, AfterViewInit } from '@angular/core';
import { saveAs } from '@progress/kendo-file-saver';
import { aggregateBy } from '@progress/kendo-data-query';
import { RowClassArgs, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { v_DispatchAttachmentBus } from '../../shared/models/v_DispatchAttachmentBus';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditAttachmentsComponent } from '@app/cp/shared/base-components/base-grid-edit-attachments.component';
import { AttachmentBus } from '@app/cp/shared/models/AttachmentBus';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { UploadComponent, FileState, SelectEvent, UploadEvent } from '@progress/kendo-angular-upload';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { timer, Subscription, fromEvent, Subject, lastValueFrom } from 'rxjs';
import { SaveMode } from '../../shared/enums/SaveMode';
import { Message } from '../../shared/models/message';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { tap, take } from 'rxjs/operators';
import * as _ from 'lodash';
import { GItem } from '../../shared/models/GItem';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseFeatureFlagSet()
@UseCPLoader()
@Component({
    selector: 'workorder-attachments',
    templateUrl: './workorder-attachments.component.html',
    styleUrls: ['./workorder-attachments.component.scss'],
    animations: [
        // Each unique animation requires its own trigger. The first argument of the trigger function is the name
        trigger('rotatedState', [
            state('default', style({ transform: 'rotate(0deg)' })),
            state('rotated1', style({ transform: 'rotate(1deg)' })),
            state('rotated359', style({ transform: 'rotate(359deg)' })),
            state('rotated90', style({ transform: 'rotate(90deg)' })),
            state('rotated180', style({ transform: 'rotate(180deg)' })),
            state('rotated270', style({ transform: 'rotate(270deg)' })),
            state('rotated360', style({ transform: 'rotate(360deg)' })),
            transition('rotated90 => rotated180', animate('400ms ease-out')),
            transition('rotated90 => default', animate('400ms ease-out')),
            transition('default => rotated90', animate('400ms ease-in')),
            transition('rotated360 => rotated90', animate('400ms ease-in')),
            transition('rotated359 => rotated270', animate('400ms ease-out')),
            transition('rotated180 => rotated90', animate('400ms ease-in')),
            transition('rotated270 => rotated180', animate('400ms ease-out')),
            transition('rotated180 => rotated270', animate('400ms ease-in')),
            transition('rotated270 => rotated360', animate('400ms ease-out')),
            transition('rotated360 => rotated270', animate('400ms ease-in')),
            transition('rotated270 => default', animate('400ms ease-out')),
            transition('default => rotated270', animate('400ms ease-in'))
        ])
    ]
})
export class WorkOrderAttachmentsComponent extends BaseGridEditAttachmentsComponent<v_DispatchAttachmentBus, null, DispatchesService> implements OnInit, AfterViewInit  {

    compLoader: ICPLoader = this as any;
    onDrop(event: any) {

    }

    compFeatureFlagSet: IFeatureFlagSet = this as any;
    resourceNameCF: MSCLFilterClass;
    attachmentTypeCF: MSCLFilterClass;
    materialTypeCF: MSCLFilterClass;
    billingCodeFC: MSFilterClass = new MSFilterClass('billingCodeId');
    reimbursementTypeFC: MSFilterClass = new MSFilterClass('reimbursementTypeId');
    cycleId: any;
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    private destroy$ = new Subject();
    private currentSubscription: Subscription;
    isUploading: boolean = false;
    selectAll: boolean = false;
    selectAllLabel: string = 'Select All to be Visible to Customer';
    @Input() isConstruction: boolean = false;

    @Output() refreshMessage: EventEmitter<Message> = new EventEmitter<Message>();
    constructor(globals: GlobalsService, private zone: NgZone, renderer: Renderer2, cd: ChangeDetectorRef, sanitizer: DomSanitizer, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, sanitizer, featureFlagService);
        this.svc_data = svc_data;
        this.className = "v_DispatchAttachmentBus";
        this.appCode = "DispatchAttachments";
        this.aggregates = [{ field: 'reimbursementAmount', aggregate: 'sum' }];
        this.saveMode = SaveMode.individual;
        this.callSaveIndividualInsteadOfSave = true;
        this.columnFocusAdder = 1;
        this.disableCpSearchDialog();
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    private includeSystemAttachments = false;
    public attachmentAction = `Show`;
    public toggleSystemAttachments(): void {
        this.includeSystemAttachments = !this.includeSystemAttachments;
        this.attachmentAction = this.includeSystemAttachments ? `Hide` : `Show`;
        const message = new Message();
        message.value = this.includeSystemAttachments;
        message.messageSubject = CommonValues.Construction_Include_System_Attachments;
        this.refreshMessage.emit(message);
    }

    stateR: string = 'default';
    stateI: number = 0;
    stateArray: string[] = ['default', 'rotated90', 'rotated180', 'rotated270',  'rotated360', 'rotated359'];
    rotate(ro:number) {
        var i = this.stateI + ro;
        if (i < 0) { i = 4      ; }
        if (i > 4) { i = 0; }
        this.stateI = i;
        this.stateR = this.stateArray[i];
        if (ro == 1 && this.stateI == 4) {
            setTimeout(() => {
                this.stateI = 0;
                this.stateR = this.stateArray[this.stateI];
                this.cd.detectChanges();

            }, 500);
        }
        if (ro == -1 && this.stateI == 4) {
            setTimeout(() => {
                this.stateI = 3;
                this.stateR = this.stateArray[this.stateI];
                this.cd.detectChanges();

            }, 100);
        }
    }
    public billingCode(id: string) {

        if (!CommonFunctions.hasStringValue(id)) {
            return null;
        }

        return this.referenceData.billingCodes?.find(x => x.value === id);
    }
    public reimbursementType(id: string) {

        if (!CommonFunctions.hasStringValue(id)) {
            return null;
        }

        return this.referenceData.reimbursementType?.find(x => x.value === id);
    }
    personCBOChanged(e: GItem, editForm) {
        if (e) {
            this.editForm.patchValue({
                personId: e.value,
                personName: e.description,
                empNo: null
            }
            )
        }
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchAttachmentId': new UntypedFormControl(),
            'dispatchAttachmentDetailId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'attachmentName': new UntypedFormControl(),
            'personName': new UntypedFormControl(),
            'attachmentType': new UntypedFormControl(),
            'billingCodeId': new UntypedFormControl(),
            'addedDate': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'attachmentDesc': new UntypedFormControl(),
            'isReimbursement': new UntypedFormControl(),
            'reimbursementAmount': new UntypedFormControl(),
            'expenseDate': new UntypedFormControl(),
            'visibleToCustomer': new UntypedFormControl(),
            'reimbursementTypeId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'isImage': new UntypedFormControl(),
            'isViewable': new UntypedFormControl(),
            'mgrApproved': new UntypedFormControl(),
            'inFinance': new UntypedFormControl(),
            'materialType': new UntypedFormControl(),
            'isRefrigerant': new UntypedFormControl(),
            'attachment': new UntypedFormControl(),
        });

    }
    setForm() {
        this.files = [];
        this.editForm.patchValue({
            dispatchAttachmentId: this.selectedData.dispatchAttachmentId,
            dispatchAttachmentDetailId: this.selectedData.dispatchAttachmentDetailId,
            dispatchId: this.isNew ? this._parentId : this.selectedData.dispatchId,
            attachmentName: this.selectedData.attachmentName,
            attachmentType: this.selectedData.attachmentType,
            attachment: this.selectedData.attachment,
            billingCodeId: this.selectedData.billingCodeId,
            addedDate: this.selectedData.addedDate,
            personId: this.selectedData.personId,
            attachmentDesc: this.selectedData.attachmentDesc,
            isReimbursement: this.selectedData.isReimbursement,
            reimbursementAmount: this.selectedData.reimbursementAmount,
            expenseDate: this.selectedData.expenseDate,
            visibleToCustomer: this.selectedData.visibleToCustomer,
            reimbursementTypeId: this.selectedData.reimbursementTypeId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            isImage: this.selectedData.isImage,
            isViewable: this.selectedData.isViewable,
            mgrApproved: this.selectedData.mgrApproved,
            inFinance: this.selectedData.inFinance,
            materialType: this.selectedData.materialType,
            isRefrigerant: this.selectedData.isRefrigerant
        });
    }
    setFromReferenceData(data: v_DispatchAttachmentBus) {
        data.personName = this.personName(data.personId);
        data.billingCode = this.referenceData.getBillingCodeDesc(data.billingCodeId);
        data.reimbursementTypeName = this.referenceData.getReimbursementTypeDesc(data.reimbursementTypeId);
        return data;
    }

    protected getChangedObject(data: v_DispatchAttachmentBus) {
        let busObj: v_DispatchAttachmentBus = new v_DispatchAttachmentBus(data);
        busObj.setParentId(this._parentId);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setBeforeSave();
        return busObj;
    }

    saveIndividual(data: v_DispatchAttachmentBus): Promise<BaseMessageInfo> {
        this.isUploading = true;
        this.dataLoading = true;
        let busObj: v_DispatchAttachmentBus = this.getChangedObject(data); // new v_DispatchAttachmentBus(data);
        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            lastValueFrom( this.svc_data.uploadAttachment(this.files, busObj)).then((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    busObj = new v_DispatchAttachmentBus(info.primaryReturn);
                    retInfo.primaryReturn = busObj;
                    this.refreshMessage.emit(null);
                    this.notify(this.appCode + " Saved Successfully!");
                } else {
                    retInfo.message = info.message;
                    retInfo.saveError = true;
                    this.saveError(info.primaryReturn as v_DispatchAttachmentBus, info.message);
                }
                this.dataLoading = false;
                this.isUploading = false;
                this.clearUpload();
                resolve(retInfo);
            }, (err) => {
                console.error(err);
                retInfo.message = `Unable to upload file. ${CommonValues.ErrorMessages_BaseErrorSuffix}`;
                retInfo.saveError = true;
                this.clearUpload();
                this.saveError(busObj, retInfo.message);
                reject(retInfo);
                this.dataLoading = false;
                this.isUploading = false;
            });
        });
    }

    ngOnInit(): void {
        window.addEventListener("drop", e => {
            e && e.preventDefault();
        }, false);
    }

    deleteIndividual(data: v_DispatchAttachmentBus) {
        if (data.hasId) {
            this.svc_data.deleteAttachment(data.CID()).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    public remove(upload: UploadComponent, uid: string) {
        upload.removeFilesByUid(uid);
    }
    public showButton(state: FileState): boolean {

        return (state === FileState.Selected) ? true : false;
    }
    focus(e: any) {
        this.ctrlOpenFlag = true;
        console.log("focus:", e);

        this.genericOpenCtrl(e);
    }

    selectEventHandler(e: SelectEvent) {
        super.selectEventHandler(e);
        CommonFunctions.patchEditFormWithAttachment(this.files?.[0], this.editForm);
    }

    get showId(): boolean {
        return this.editedRowIndex == undefined && this.isNew == false ? true : false;
    }
    view(data: any) {
        let dataObj: v_DispatchAttachmentBus = data as v_DispatchAttachmentBus;
        let busObj: AttachmentBus = new AttachmentBus();
        busObj.id = dataObj.dispatchAttachmentDetailId;
        this.cycleId = dataObj.dispatchAttachmentId;
        this.stateI = 0;
        this.stateR = this.stateArray[this.stateI];
        super.view(busObj);
    }
    showPrev() {
        this.stateI = 0;
        this.stateR = this.stateArray[this.stateI];
        let filterIndex = this.gridData.findIndex(element => { return element.dispatchAttachmentId === this.cycleId })
        let newindex = filterIndex - 1
        if (newindex < 0) { newindex = this.gridData.length-1}
        let data = this.gridData[newindex];
        let dataObj: v_DispatchAttachmentBus = data as v_DispatchAttachmentBus;
        let busObj: AttachmentBus = new AttachmentBus();
        busObj.id = dataObj.dispatchAttachmentDetailId;
        this.cycleId = dataObj.dispatchAttachmentId
        super.view(busObj);

    }
    showNext() {
        this.stateI = 0;
        this.stateR = this.stateArray[this.stateI];
        let filterIndex = this.gridData.findIndex(element => { return element.dispatchAttachmentId === this.cycleId })
        let newindex = filterIndex + 1
        if (newindex >= this.gridData.length) { newindex = 0; }
        let data = this.gridData[newindex];
        let dataObj: v_DispatchAttachmentBus = data as v_DispatchAttachmentBus;
        let busObj: AttachmentBus = new AttachmentBus();
        busObj.id = dataObj.dispatchAttachmentDetailId;
        this.cycleId = dataObj.dispatchAttachmentId
        super.view(busObj);

    }
    mgrApprove(dataItem: v_DispatchAttachmentBus) {
        this.dataLoading = true;
        this.svc_data.saveDispatchAttachmentApproved(dataItem.dispatchAttachmentId).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let newBusObj: v_DispatchAttachmentBus = new v_DispatchAttachmentBus(info.primaryReturn);
                newBusObj.mgrApproved = true;
                this.saveSuccess(newBusObj);
            }
            else {
                this.saveError(info.primaryReturn as v_DispatchAttachmentBus, info.message);
            }
            this.dataLoading = false;
            this.clearUpload();
        });
    }
    download(data: any) {
        let dataObj: v_DispatchAttachmentBus = data as v_DispatchAttachmentBus;
        let busObj: AttachmentBus = new AttachmentBus();
        busObj.id = dataObj.dispatchAttachmentDetailId;
        super.download(busObj);
    }
    downloadingAllItems: boolean = false;
    downloadingAllItemsPhase: number = 0;

    downloadAll() {
        this.downloadingAllItems = true;
        this.downloadingAllItemsPhase = 1;
        this.dataLoading = true;
        this.svc_data.attachmentsDownloadAllStream(this.parentId).subscribe((response): void => {
            console.log("attachmentsDownloadAllStream: ", response, response.size); //, blob, response.body);
            let size: number = response.size / 10000; //info.dcValues.FileSize/1000;
            let msecs = 5000;
            if (size > 175000) {
                msecs = 115000;
            }
            else if (size > 125000) {
                msecs = 50000;
            }
            else if (size > 75000) {
                msecs = 30000;
            }
            else if (size > 5000) {
                msecs = 15000;
            }
            this.downloadingAllItemsPhase = 2;
            var fileName = "Attachments-" + this.primaryNumber + ".zip";
            saveAs(response, fileName);
            timer(msecs).subscribe(s => {
                this.dataLoading = false;
                this.downloadingAllItems = false;
                this.downloadingAllItemsPhase = 0;
            });
        });
    }
    downloadAllX() {
        this.downloadingAllItems = true;
        this.downloadingAllItemsPhase = 1;
        this.dataLoading = true;
        this.svc_data.attachmentsDownloadAll(this.parentId).subscribe((info: BaseMessageInfo) => {
            console.log("attachmentsDownloadAll: ", info);
            let downloadData = "data:application/zip;base64," + info.primaryReturn.document;
            let size: number = info.dcValues.FileSize / 1000;
            let msecs = 5000;
            if (size > 175000) {
                msecs = 115000;
            }
            else if (size > 125000) {
                msecs = 50000;
            }
            else if (size > 75000) {
                msecs = 30000;
            }
            else if (size > 5000) {
                msecs = 15000;
            }
            this.downloadingAllItemsPhase = 2;
            saveAs(downloadData, info.primaryReturn.fileName);
            timer(msecs).subscribe(s => {
                this.dataLoading = false;
                this.downloadingAllItems = false;
                this.downloadingAllItemsPhase = 0;
            });
        });
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
            this.resourceNameCF = new MSCLFilterClass('personName', 'personName', this.gridData);
            this.attachmentTypeCF = new MSCLFilterClass('attachmentType', 'attachmentType', this.gridData);
            this.materialTypeCF = new MSCLFilterClass('materialType', 'materialType', this.gridData);
        }
        else {
            this.aggregateResults = null;
        }
        this.getDragReady();
    }
    rowClassFunction(context: RowClassArgs) {
        if (context.dataItem.inFinance) {
            return { inFinance: true }
        }
    }
    canDelete(dataItem: v_DispatchAttachmentBus): boolean {
        return !dataItem.inFinance || this.rights.FinancialLockOverride;
    }
    canEditRow(dataItem: v_DispatchAttachmentBus) {
        return !dataItem.inFinance || this.rights.FinancialLockOverride;
    }
    get canSave(): boolean {
        if (!this.editForm) { return true };
        if (this.editForm.controls["reimbursementAmount"].value) {
            var matval = this.editForm.controls["materialType"].value
            if (!matval) { return false;}
        }
        return true;
    }
    customCanSaveForm() {
        if (!this.editForm) { return true };
        if (this.editForm.controls["reimbursementAmount"].value) {
            var matval = this.editForm.controls["materialType"].value
            if (!matval) { return false; }
        }
        return true;
    }
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
        if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }
    }

    public ngAfterViewInit(): void {
        this.getDragReady();
    }
    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.getDragReady();
    }
    private handleDragAndDrop(): Subscription {
        const sub = new Subscription(() => { });
        let draggedItemIndex;
        const tableRows = Array.from(document.querySelectorAll('div.attachmentGridDiv > .k-grid tr'));
        const _this = this;
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(
                tap(({ dataTransfer }) => {
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];
            }));

            sub.add(dragEnd.subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.detailType = 3;
                event.dropid = event.dispatchAttachmentId

                this.dropEvent.emit(event);
            }));
        });

        return sub;
    }
    primaryNumber: string = "";
    protected parentIdChanged() {
        super.parentIdChanged();
        this.svc_data.getPrimaryNumber(this.parentId).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.primaryNumber = info.primaryReturn;
            }
        });
    }

    selectAllChanged() {
        this.selectAll = !this.selectAll;
        this.checkAll(this.selectAll);
    }

    checkAll(checked: boolean) {
        for (const element of this.gridData) {
            element.visibleToCustomer = checked;
            this.saveIndividual(element);
        }
        this.processGridData();
        // change label
        if (this.selectAll) {
            this.selectAllLabel = 'Unselect All Visible To Customer';
        }
        else {
            this.selectAllLabel = 'Select All Visible To Customer';
        }
    }
}
